const LoaderSize = {
  Normal: 'normal',
  Massive: 'massive',
};

export default LoaderSize;
